
import wxBridge from '../jsbridge/jsbridge_base.js';

wxBridge.startGameLifeConversation = wxBridge.startGameLifeConversation || function (param, callback) {
    wxBridge.invoke('startGameLifeConversation', param, callback);
};

export default wxBridge;

export const {
    startGameLifeConversation
} = wxBridge;
